import { render, staticRenderFns } from "./contentTagActive.vue?vue&type=template&id=50d2e538&"
import script from "./contentTagActive.vue?vue&type=script&lang=js&"
export * from "./contentTagActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports